// ============================================================================
// 🔷 SEARCH STORE (store central de búsqueda dinámica)
//    💡 Esta store mantiene una referencia a la store de búsqueda activa.
//       Se utiliza como intermediario para redirigir acciones `search()`
//       a la store de la vista en uso (clientes, pedidos, etc).
// ============================================================================

import { defineStore } from "pinia";
import type { ISearchStore } from "@/interfaces/stores/ISearchStore";

export const useSearchStore = defineStore("searchStore", {
  state: () => ({
    /**
     * 🔁 Referencia a la store actual de búsqueda.
     *    Esta propiedad debe establecerse desde cada vista o componente que utilice una búsqueda.
     *    Permite redirigir la acción genérica `search()` al store adecuado en cada contexto.
     */
    currentSearchStore: null as ISearchStore | null,
  }),

  actions: {
    // ─────────────────────────────────────────────────────────────
    // 🧩 Asigna la store de búsqueda activa
    //    💡 Debe llamarse al cargar cada vista para enlazar su propia store.
    // ─────────────────────────────────────────────────────────────
    setSearchStore(store: ISearchStore) {
      this.currentSearchStore = store;
    },

    // ─────────────────────────────────────────────────────────────
    // 🔍 Ejecuta una búsqueda redirigiendo a la store activa
    //    💡 Llama al método `search()` de la store asignada.
    // ─────────────────────────────────────────────────────────────
    async search(query: any, token: string) {
      if (this.currentSearchStore) {
        await this.currentSearchStore.search(query, token);
      } else {
        console.error("❌ No hay una searchStore asignada.");
      }
    },
  },
});
